import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import { API_BASE_URL } from "configs/AppConfig";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function Card({ url, isInternal = null, title, isPDF = null, description, translation }) {

  const dir = useSelector(({theme})=>theme.direction);

  const currentLocale = useSelector(({ theme }) => theme.locale);

  const service_box = (
    <div className="services-box">
      <div className="sb-head">
        <h6>
          <LabelLang
            id={'title'}
            defaultValue={title}
            translations={translation}
          />
        </h6>
        {isPDF ? (
          <ArrowCircleDownIcon
            sx={{ color: "#fff", fontSize: "1.85rem" }}
          />
        ) : (
          <img
            className={`img1 ${dir === 'rtl' ? 'r-dir' : 'l-dir'}`}
            src={process.env.PUBLIC_URL + "/image/sb.svg"}
            alt="arrow"
            loading="lazy"
          />
        )}
      </div>
      <div className="sb-body">
        <p
          title={LabelLangString({
            id: "description",
            currentLocale: currentLocale,
            defaultValue: description,
            translations: translation
          })}
        >
          {LabelLangString({
              id: "description",
              currentLocale: currentLocale,
              defaultValue: description,
              translations: translation
          })?.length > 200 ?
              `${LabelLangString({
                id: "description",
                currentLocale: currentLocale,
                defaultValue: description,
                translations: translation
              }).slice(0,200)}...`
              :
              LabelLangString({
                id: "description",
                currentLocale: currentLocale,
                defaultValue: description,
                translations: translation
              })
          }
        </p>
      </div>
      <img
        width={60}
        height={60}
        className="img1 watermark"
        src={process.env.PUBLIC_URL + "/image/pi.svg"}
        alt="bg-fixed"
        loading="lazy"
      />
    </div>
  )

  return (
    <div className="service-item">
      {isInternal ?
        <Link to={`${url}`}>
          {service_box}
        </Link>
        :
        <a href={`${isPDF ? API_BASE_URL : ''}${url}`} target="_blank" rel="noreferrer">
          {service_box}
        </a>
      }
    </div>
  );
}
